import { useState } from "react";
import axios from "axios";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import WhatsAppIcon from "@mui/icons-material/WhatsApp"; // Importar el icono de WhatsApp
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";
import bgImage from "assets/images/foro.jpg";
import Resizer from "react-image-file-resizer";
import Swal from "sweetalert2";
import { Box, Button, CardContent, Typography } from "@mui/material";

const API_URL = "https://portaltransaccionalback.azurewebsites.net/api/InscribeUsuarios"; // Reemplázalo con tu endpoint real

function SignInBasic() {
  const [miembros, setMiembros] = useState([
    { id: 1, nombre: "", correo: "", documento: "", imagen: null, errores: {} },
    { id: 2, nombre: "", correo: "", documento: "", imagen: null, errores: {} },
  ]);

  const [cargando, setCargando] = useState(false);

  const agregarMiembro = () => {
    if (miembros.length >= 3) {
      Swal.fire("Límite alcanzado", "No puedes inscribir más de 3 participantes.", "warning");
      return;
    }

    setMiembros([
      ...miembros,
      { id: Date.now(), nombre: "", correo: "", documento: "", imagen: null, errores: {} },
    ]);
  };

  const eliminarMiembro = (id) => {
    if (miembros.length > 2) {
      setMiembros(miembros.filter((miembro) => miembro.id !== id));
    } else {
      Swal.fire("Mínimo requerido", "Debe haber al menos 2 participantes.", "warning");
    }
  };

  const calcularValor = () => {
    const cantidadPersonas = miembros.length;
    let valorTotal = 0;

    if (cantidadPersonas === 1) {
      valorTotal = "Agrega Otro participante";
    } else if (cantidadPersonas === 2) {
      valorTotal = 700000;
    } else if (cantidadPersonas === 3) {
      valorTotal = 750000;
    }

    return valorTotal;
  };

  const manejarCambio = (id, campo, valor) => {
    if (campo === "imagen") {
      const file = valor;
      if (file) {
        Resizer.imageFileResizer(
          file,
          300, // Ancho máximo
          300, // Alto máximo
          "JPEG", // Formato de salida
          50, // Calidad (0-100)
          0, // Rotación
          (uri) => {
            setMiembros(
              miembros.map((miembro) => (miembro.id === id ? { ...miembro, imagen: uri } : miembro))
            );
          },
          "base64"
        );
      }
    } else {
      setMiembros(
        miembros.map((miembro) => (miembro.id === id ? { ...miembro, [campo]: valor } : miembro))
      );
    }
  };

  const validarCampos = () => {
    let esValido = true;
    const nuevosMiembros = miembros.map((miembro) => {
      const errores = {};
      if (!miembro.nombre.trim()) errores.nombre = "El nombre es obligatorio";
      if (!miembro.correo.trim()) errores.correo = "El correo es obligatorio";
      if (!miembro.documento.trim()) errores.documento = "El documento es obligatorio";
      if (Object.keys(errores).length > 0) esValido = false;
      return { ...miembro, errores };
    });

    setMiembros(nuevosMiembros);
    return esValido;
  };

  const manejarEnvio = async (e) => {
    e.preventDefault();

    if (miembros.length < 2 || miembros.length > 3) {
      Swal.fire("Atención!", "Debes inscribir entre 2 y 3 participantes.", "info");
      return;
    }

    if (!validarCampos()) return;

    setCargando(true);
    try {
      const cantidadPersonas = miembros.length;

      const precios = {
        2: 700000,
        3: 750000,
      };

      const valorTotal = precios[cantidadPersonas] || 0;

      const grupoId = Math.floor(10000 + Math.random() * 90000000);

      const estudiantes = miembros.map((miembro) => ({
        grupoId,
        nombre: miembro.nombre,
        correo: miembro.correo,
        documento: miembro.documento,
        imagen: miembro.imagen,
        evento: "ForoCalidad",
      }));

      const datosJSON = {
        estudiantes,
        valor: valorTotal.toString(),
      };

      console.log("Datos enviados en JSON:", JSON.stringify(datosJSON, null, 2));

      const response = await axios.post(API_URL, datosJSON, {
        headers: { "Content-Type": "application/json" },
      });

      console.log(response.data);

      if (response.data) {
        Swal.fire({
          title: "Registro exitoso",
          text: `¡Tu grupo ha sido registrado con éxito!   
         
          Nota: Al hacer clic en "Ir a Pagar", serás redirigido al portal de pago oficial.`,
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "Ir a Pagar",
          cancelButtonText: "Cerrar",
        }).then((result) => {
          if (result.isConfirmed) {
            window.open(response.data, "_blank");
          }
        });
      } else {
        Swal.fire("Registro exitoso", "No se recibió una URL.", "success");
      }

      setMiembros([
        { id: 1, nombre: "", correo: "", documento: "", imagen: null, errores: {} },
        { id: 2, nombre: "", correo: "", documento: "", imagen: null, errores: {} },
      ]);
    } catch (error) {
      console.log(error);
      console.error("Error al enviar datos:", error);
      Swal.fire("Error", "Hubo un problema al enviar los datos", "error");
    } finally {
      setCargando(false);
    }
  };

  return (
    <>
      <MKBox
        position="absolute"
        top={0}
        left={0}
        zIndex={1}
        width="100%"
        minHeight="100vh"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
        }}
      />

      <MKBox
        px={1}
        width="100%"
        minHeight="100vh"
        mx="auto"
        position="relative"
        zIndex={2}
        sx={{
          overflowY: "auto",
          maxHeight: "100vh",
        }}
      >
        <Grid container spacing={1} justifyContent="center" alignItems="center" height="100%">
          <Grid item xs={12} sm={10} md={8} lg={7} xl={6}>
            <Card sx={{ maxHeight: "auto", width: "100%", overflowY: "auto", mt: 1 }}>
              <MKBox
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                mx={2}
                mt={3}
                p={2}
                mb={4}
                textAlign="center"
              >
                <MKTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                  Formulario de Inscripción
                  <br /> Foro Calidad 2025
                </MKTypography>
              </MKBox>

              <MKBox pt={4} pb={3} px={3}>
                <MKBox component="form" role="form" onSubmit={manejarEnvio}>
                  {miembros.map((miembro, index) => (
                    <MKBox
                      key={miembro.id}
                      mb={2}
                      p={2}
                      border="1px solid #ddd"
                      borderRadius="8px"
                      position="relative"
                    >
                      <MKTypography variant="h6" color="text">
                        Participante {index + 1}
                      </MKTypography>
                      {miembros.length > 1 && (
                        <IconButton
                          aria-label="Eliminar"
                          size="small"
                          onClick={() => eliminarMiembro(miembro.id)}
                          sx={{ position: "absolute", top: 8, right: 8 }}
                        >
                          <DeleteIcon color="error" />
                        </IconButton>
                      )}
                      <MKBox mb={2}>
                        <MKInput
                          type="text"
                          label="Nombre *"
                          fullWidth
                          value={miembro.nombre}
                          onChange={(e) => manejarCambio(miembro.id, "nombre", e.target.value)}
                          error={!!miembro.errores.nombre}
                          helperText={miembro.errores.nombre}
                        />
                      </MKBox>
                      <MKBox mb={2}>
                        <MKInput
                          type="email"
                          label="Correo *"
                          fullWidth
                          value={miembro.correo}
                          onChange={(e) => manejarCambio(miembro.id, "correo", e.target.value)}
                          error={!!miembro.errores.correo}
                          helperText={miembro.errores.correo}
                        />
                      </MKBox>
                      <MKBox mb={2}>
                        <MKInput
                          type="number"
                          label="Número de Documento *"
                          fullWidth
                          value={miembro.documento}
                          onChange={(e) => manejarCambio(miembro.id, "documento", e.target.value)}
                          error={!!miembro.errores.documento}
                          helperText={miembro.errores.documento}
                        />
                      </MKBox>
                    </MKBox>
                  ))}
                  <MKBox mt={2} mb={2} textAlign="center">
                    <MKButton variant="outlined" color="info" onClick={agregarMiembro}>
                      Agregar nuevo participante
                    </MKButton>
                  </MKBox>
                  <MKTypography variant="h6" color="text">
                    Total a pagar: ${calcularValor().toLocaleString()} COP
                  </MKTypography>

                  <MKBox mt={4} mb={1}>
                    <MKButton
                      variant="gradient"
                      color="info"
                      fullWidth
                      type="submit"
                      disabled={cargando}
                    >
                      {cargando ? "Enviando..." : "Enviar"}
                    </MKButton>
                  </MKBox>
                </MKBox>
              </MKBox>

              {/* Aquí se coloca el bloque con los WhatsApp */}
              <MKBox px={1} pt={-2}>
                <Card sx={{ padding: 2, maxWidth: "auto", mx: "auto" }}>
                  <CardContent>
                    <Typography variant="body1" color="text">
                      O puedes comunicarte directamente con nuestras ejecutivas:
                    </Typography>

                    <Box display="flex" alignItems="center" mt={1}>
                      <WhatsAppIcon color="success" />
                      <Typography variant="body2" color="text" ml={1}>
                        Maria Camila Guerrero - 3104780772
                      </Typography>
                      <Button
                        variant="text"
                        color="info"
                        href="https://wa.me/3104780772"
                        target="_blank"
                        sx={{ ml: 1 }}
                      >
                        Contactar
                      </Button>
                    </Box>

                    <Box display="flex" alignItems="center" mt={2}>
                      <WhatsAppIcon color="success" />
                      <Typography variant="body2" color="text" ml={1}>
                        Paula Guerrero - 3138872014
                      </Typography>
                      <Button
                        variant="text"
                        color="info"
                        href="https://wa.me/message/FP4JZQV4RXVMJ1"
                        target="_blank"
                        sx={{ ml: 1 }}
                      >
                        Contactar
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              </MKBox>
            </Card>
          </Grid>
        </Grid>
      </MKBox>
    </>
  );
}

export default SignInBasic;
